export class CommunicationSetup {
    communicationSetupId: number;
    subcriptionType: string;
    subcriberName: string;
    subcriberEmail: string;    
}